import { useState } from "react";

import Box from "@mui/material/Box";

import Assets, { getAssetValidity } from "./Assets";
import Liabilities, { getLiabilityValidity } from "./Liabilities";
import Summary from "./Summary";
import AssetAndLiabilityDeclaration from "./AssetsAndLiabilitiesDeclaration.js";

import PageNavigator, { onNext } from "../../../PageNavigator";

export default function AssetsAndLiabilities() {
  /**
   * TRUE - WHEN COMPONENT IS VALID AND "NEXT PAGE" BUTTON IS ENABLED
   *        ALL SUB COMPONENTS SHOULD BE VALID FOR THIS TO BE TRUE
   */
  const [enableNext, setEnableNext] = useState(false);

  function validateForm(e) {
    e.preventDefault();
    if (getAssetValidity() && getLiabilityValidity()) onNext();
  }

  return (
    <>
      <Box component="form" onSubmit={validateForm} noValidate>
        <Assets setEnableNext={setEnableNext} />
        <Liabilities setEnableNext={setEnableNext} />
        <Summary />
        <AssetAndLiabilityDeclaration setEnableNext={setEnableNext} />
        <PageNavigator validator={validateForm} isValid={enableNext} />
      </Box>
    </>
  );
}
